import { requestApi } from '../util/network'

// 获取订单信息
export const buyStep1 =
(cart_id, ifcart, platform) =>
  requestApi(
    '/memberbuy/buy_step1',
    'POST',
    {
      'cart_id': cart_id,
      'ifcart': ifcart,
      'platform': platform
    },
    'member'
  )

// 下单入库
export const buyStep2 =
    (payload) =>
      requestApi(
        '/memberbuy/buy_step2',
        'POST',
        {
          'sold_out_option': payload.soldOutOption,
          'ifcart': payload.hasShoppingCart,
          'cart_id': payload.cartIds,
          'address_id': payload.addressId,
          'vat_hash': payload.vatHash,
          'invoice_id': payload.invoiceId,
          'payment_code': payload.paymentCode,
          'payment_id': payload.paymentId,
          'voucher': payload.voucher,
          'pay_message': payload.payMessage,
          'expect_time': payload.expectTime
        },
        'member'
      )

// 获取订单支付信息
export const getOrderpayInfo =
    (paySn) =>
      requestApi(
        '/memberbuy/pay',
        'POST',
        {
          'pay_sn': paySn
        },
        'member'
      )
